






import Vue from 'vue';

export interface DropdownOption {
  value: string;
}

export default Vue.extend({
  name: 'Dropdown',
  props: {
    value: String,
    count: Number,
    isActive: Boolean,
  },
  computed: {
    countValue() {
      return this.count ? `(${this.count})` : '';
    },
  },
});
